import { PAUSED_UPLOAD_TTL_HOURS } from "@/components/UploadProgress/UploadProgressLoadingCard";
import { DemoUploadCard } from "../demo/DemoUploadCard";
import { ArticleBody, ArticleCallout, ArticleDemoFrame } from "./Article.elements";

export const MoveToAnotherDeviceArticle = () => (
  <ArticleBody>
    <h3>Started on the laptop, finishing at the desk</h3>
    <p>
      An upload belongs to your account, not to the computer it started on. Every chunk that reached the server
      stays there, so you can pick the package up from any other browser or machine you are signed in on — the
      newsroom desktop with the fast line, for example.
    </p>

    <h3>What you see on the other device</h3>
    <ArticleDemoFrame>
      <DemoUploadCard state="anotherDevice" />
    </ArticleDemoFrame>
    <p>
      Under <strong>Uploading</strong> the package appears marked <em>another device</em> (paused or still
      sending). Because an account runs one upload at a time, this device won&apos;t start sending until you
      press <strong>Take over here</strong>.
    </p>

    <h3>Taking over, step by step</h3>
    <ol>
      <li>Pause on the first device if it is still uploading (or just close its tab).</li>
      <li>Sign in on the second device and open <strong>Uploading</strong>.</li>
      <li>
        Press <strong>Take over here</strong>. The card becomes yours on this device and shows{" "}
        <em>Select files / Select folder</em>.
      </li>
      <li>
        Select the <strong>same files</strong> (or the same folder). The uploader compares them with what the server
        already has and skips every finished chunk. Only the missing bytes are sent.
      </li>
    </ol>

    <ArticleCallout>
      Nothing is re-uploaded. Taking over does not restart the package — it continues it. You have{" "}
      <strong>{PAUSED_UPLOAD_TTL_HOURS} hours</strong> from the pause to do this.
    </ArticleCallout>

    <h3>Good to know</h3>
    <ul>
      <li>
        The files must be the same files. Copy them to the second machine (card reader, drive, network share) before
        taking over.
      </li>
      <li>
        If the first device is still uploading when you take over, it stops and shows the package as{" "}
        <em>another device</em> from its point of view.
      </li>
      <li>Do not press Cancel to &ldquo;free&rdquo; the upload — that deletes it. Take over instead.</li>
    </ul>
  </ArticleBody>
);
